require('./empty-box.scss');

const EmptyBoxComponent = {
    selector: 'sbEmptyBox',
    template: require('./empty-box.html'),
    bindings: {
        title: '@',
        message: '@',
        iconCss: '@',
    },
};

export default EmptyBoxComponent;



// WEBPACK FOOTER //
// ./src/app/components/empty-box/index.js